import classNames from 'clsx';
import { Col } from 'aui';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
import type { MdComponentIndexProps } from '../type';
// import { useRef } from 'react';
// import styles from './Tooltip.module.less';

type MarkdownRowProps = React.ComponentProps<typeof Col>;

function validateBreakPoint(xs: MarkdownRowProps['xs']) {
  if (!isNumber(xs) && !isObject(xs)) return undefined;
  return xs;
}

export function validateColProps(props: MarkdownRowProps) {
  const res = { ...props };

  if (!isNumber(props.flex) && !isString(props.flex)) res.flex = undefined;
  if (!isNumber(props.offset)) res.offset = undefined;
  if (!isNumber(props.order)) res.order = undefined;
  if (!isNumber(props.pull)) res.pull = undefined;
  if (!isNumber(props.push)) res.push = undefined;
  if (!isNumber(props.span)) res.span = undefined;
  res.xs = validateBreakPoint(res.xs);
  res.sm = validateBreakPoint(res.sm);
  res.md = validateBreakPoint(res.md);
  res.lg = validateBreakPoint(res.lg);
  res.xl = validateBreakPoint(res.xl);
  res.xxl = validateBreakPoint(res.xxl);
  return res;
}

export function MarkdownCol(
  props: React.PropsWithChildren<MarkdownRowProps & MdComponentIndexProps>,
) {
  return (
    <Col
      {...validateColProps(props)}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {props.children ? (
        <div className={classNames('markdown-child-root')}>{props.children}</div>
      ) : null}
    </Col>
  );
}

MarkdownCol.attributes = [
  'flex',
  'offset',
  'order',
  'pull',
  'push',
  'span',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
  'className',
  'style',
];
// MarkdownCol.inline = false;
MarkdownCol.displayName = 'MarkdownCol';
